export default __webpack_public_path__ + "static/media/background.5fad6371.jpg";